import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import Select from "react-select";

class FormCreate extends Component {

    handleSubmit = e => {
        e.preventDefault();
    };

    render() {
        const { formValues, errorValues } = this.props;
        const isError = errorValues === false;

        return (
            <Modal
                isOpen={this.props.modal}
                toggle={this.props.toggle}
                className="modal-dialog-centered rk-modal"
                backdrop={this.props.backdrop}
            >
                <div className="rk-modal__header">
                    <span className="rk-modal__header-icon"><i className="fas fa-shield-alt"></i></span>
                    <h5>{this.props.title}</h5>
                    <button type="button" className="rk-modal__close" onClick={() => this.props.toggle()}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <form onSubmit={this.handleSubmit}>
                    <div className="rk-modal__body">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="rk-field">
                                    <label className="rk-label">Fecha de análisis</label>
                                    <input
                                        type="date"
                                        name="date_of_analysis"
                                        value={formValues.date_of_analysis}
                                        onChange={this.props.onChangeForm}
                                        className={`rk-input ${isError && formValues.date_of_analysis == "" ? "rk-input--error" : ""}`}
                                    />
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="rk-field">
                                    <label className="rk-label">Proceso</label>
                                    <Select
                                        onChange={this.props.handleChangeAutocompleteProceso}
                                        options={this.props.procesos}
                                        autoFocus={false}
                                        classNamePrefix="select"
                                        placeholder="Seleccione"
                                        className={isError && formValues.proceso_id == "" ? "rk-input--error" : ""}
                                        value={this.props.selectedOptionProcesos}
                                    />
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="rk-field">
                                    <label className="rk-label">Responsable</label>
                                    <Select
                                        onChange={this.props.handleChangeAutocomplete}
                                        options={this.props.users}
                                        autoFocus={false}
                                        classNamePrefix="select"
                                        placeholder="Seleccione"
                                        className={isError && formValues.responsable_id == "" ? "rk-input--error" : ""}
                                        value={this.props.selectedOption}
                                    />
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="rk-field">
                                    <label className="rk-label">Participantes</label>
                                    <Select
                                        onChange={this.props.handleChangeAutocompleteUsers}
                                        options={this.props.users}
                                        value={this.props.selectedOptionUsers}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        autoFocus={false}
                                        classNamePrefix="select"
                                        placeholder="Seleccione uno o varios"
                                    />
                                </div>
                            </div>

                            {isError && (
                                <div className="col-md-12">
                                    <div className="rk-alert">
                                        <i className="fas fa-exclamation-circle"></i>
                                        Debes completar todos los campos requeridos
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="rk-modal__footer">
                        <button type="button" className="rk-btn rk-btn--ghost" onClick={() => this.props.toggle()}>
                            Cerrar
                        </button>
                        <button type="button" className="rk-btn rk-btn--primary" onClick={this.props.submitForm}>
                            <i className="fas fa-check"></i> {this.props.nameSubmit}
                        </button>
                    </div>
                </form>
            </Modal>
        );
    }
}

export default FormCreate;
